/**
 * Central query-key factory (frontend-architecture R4).
 * Every hook in apps/ui/web reads keys from here — no hand-spelled array
 * literals at call sites. Keys follow the PLAN §5.3.2 hierarchy:
 * [domain, sub-domain, ...identifiers].
 */
export const keys = {
  workstream: {
    all: () => ['workstream'] as const,
    createChat: () => ['workstream', 'create', 'chat'] as const,
    create: () => ['workstream', 'create'] as const,
    /** Post-creation chat turn (Librarian), scoped to one workstream. */
    chat: (workstreamId: string) => ['workstream', 'chat', workstreamId] as const,
    /** The caller's workstreams (S-C1) — fed by `GET /api/v1/workstream`. */
    listMine: () => ['workstream', 'list', 'mine'] as const,
    /** One workstream's artifacts (Drop 6 / S09) — `GET /workstreams/{id}/artifacts`. */
    artifacts: (workstreamId: string) => ['workstream', 'artifacts', workstreamId] as const,
    /**
     * One artifact fetched for viewing (Drop 6 / S11) —
     * `GET /workstreams/{id}/artifacts/{artifactId}`. Nested UNDER the list key so
     * the S10 delete's list invalidation (prefix match) also drops a viewed file's
     * cache — a file deleted while open then 404s and the View pane self-heals.
     */
    artifact: (workstreamId: string, artifactId: string) =>
      ['workstream', 'artifacts', workstreamId, artifactId] as const,
    /**
     * Delete-artifact mutation (Drop 6 / S10). Its own `mutationKey` so a failed
     * delete is attributable in the shared `MutationCache.onError` sink (which
     * forwards `mutation.options.mutationKey` to `reportError`) — consistent with
     * every other app mutation.
     */
    deleteArtifact: (workstreamId: string) =>
      ['workstream', 'artifacts', 'delete', workstreamId] as const,
  },
} as const;
